import script from "./AfterSalesItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./AfterSalesItem.vue?vue&type=script&lang=ts&setup=true"

import "./AfterSalesItem.vue?vue&type=style&index=0&id=2a3a7a2a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a3a7a2a"]])

export default __exports__